<!--
	Name:			batch.vue
	Description:	Show the batch as a timeline block
	Remarks:		The position on the timeline is managed by the timestore repository
-->

<template>

	<!--left = endTime, position the batch to the left (margin-left:-100%)-->
	<div class="batch time-block accent-background-light" :class="batchClass" :style="{left: xPosition + '%',  width : width + '%'}" v-on:click.stop="showBatchInAlert('')">
	
		<div class="batch-product-wrp" v-bind:key="product.id" v-for="product in batch.products">
			<div v-if="batch.paddingLeft" class="batch-span padding-left" :style="{flex: (batch.paddingLeft / (batch.paddingLeft + batch.paddingRight)) }">
				&nbsp;
			</div>
			<div class="product" :style="{width: productWidth(product) + '%'}">
				<div class="product-name-scam">
					<span>
						{{product.name}} <span>{{product.preperation}}</span>
					</span>
				</div>
				<div class="product-block">

				</div>
				<div class="product-name">
					{{product.name}} <span>{{product.preperation}} <!--<span class="teststck" style="position:absolute;right:0px;background-color:wheat">[{{batch.id}} -  {{stack}} ]</span>--></span>
				</div>
			</div>
			<div v-if="batch.paddingRight" :style="{flex: (batch.paddingRight / (batch.paddingLeft + batch.paddingRight)) }" class="batch-span padding-right">
				&nbsp;
			</div>
			
		</div>
	</div>
</template>

<script>
	import timeStore from '../repositories/TimeManager';
	import batchDetail from '../components/BatchDetail';
	import Vue from 'vue';

	const Batch = {

		props: {
			//	StartDate: {
			//		type: Date
			//	},
			//	EndDate: { type: Date },
          
			// Zoom: { type: Number, default: 100 },
			batch: { type: Object }
		},

		data: function () {
            return { timeStoreState: timeStore.state };
		},

		methods: {
			/**
			 * Returns the width of the product in percentage.
			 * @param product the product
			 */
			productWidth: function (product) {
				return ((product.cookingTime / this.batch.totalTime) * 100).toFixed(4);
			},
			/**
			 * Returns the classname of the order.
			 * @param order
			 */
			orderClass: function (order) {
				var className = {};
				className['accent' + order.accentColor] = 1;
				className['batch-order-name']
				return className;

			},

			showBatchInAlert: function (message, toast) {

				// create batchDetail vue compnent
				// https://css-tricks.com/creating-vue-js-component-instances-programmatically/
				var ComponentClass = Vue.extend(batchDetail);


				// set properties
				var _batchDetail = new ComponentClass({
					propsData: { Batch: this.batch, Message: message }
				});

				_batchDetail.$mount();

				var props = {
					// title: "Batch",
				// 	html: _batchDetail.$el.outerHTML,
					showConfirmButton: false,
					 customClass: {
                        container: 'order-detail'
					},
                    padding: '0px',
                    onOpen: function (ell) {
                        ell.children[1].appendChild(_batchDetail.$el);
					} 
					
				}

				if (toast) {
					props.toast = true;
					props.timer=  6000;
					props.timerProgressBar = true;
					props.position =  'top-end';
				}

				// https://sweetalert2.github.io/#configuration
				this.$fire(props).then(() => {
					_batchDetail.$destroy();
				});

			},

			calculatePosition: function () {

                // calculate the occupied width               
                var maxWidth = this.$el.scrollWidth;
				this.batch.scrollRight = this.$el.offsetLeft + maxWidth;

                var products = this.$el.querySelectorAll(".product-name");
                products.forEach(function (el) {
                    var width = el.scrollWidth;
                    maxWidth = width > maxWidth ? width : maxWidth;
				});

                this.batch.scrollLeft = this.batch.scrollRight - maxWidth;

                // rect.right;

                this.batch.scrollWidth = maxWidth;
                this.batch.domCalculated = true;
            }
		},

		computed: {
			
			/*
			 * Returns the status class of the batch
			 */
			batchClass: function () {
				var className = {};
				className['status' + this.batch.status] = 1;
				className['id-' + this.batch.id] = 1;
				className['with-left-padding'] = this.batch.paddingLeft;
                className['with-right-padding'] = this.batch.paddingRight;
		
				return className;
			},

			/** 
			 * Returns the width of the batch 
			 * 
			 */
			width: function () {
				return timeStore.calculateBatchWidth(this.batch);
			},
			xPosition: function () {
				return timeStore.calculateBatchPosition(this.batch);
			},

			stack: function () {
				return this.batch.stack;
			}

		},


		watch: {
            "batch.stack" :
                function (newvalue) {	//newvalue, oldvalue				
						// this.$el.style.top = (newvalue * 30) + 'px';                    					
				},
            "timeStoreState.zoom": function () { //newval, oldval
                this.calculatePosition();
			}
		},

        mounted: function () {
			this.calculatePosition();			
		}, 
		updated: function () {
			this.$nextTick(function () {
                this.calculatePosition();			
			});            
        }

	};

	export { Batch as default };

</script>
